import React, {useEffect, useState} from 'react';
import {createMuiTheme, ThemeProvider} from '@material-ui/core/styles';
import {cyan, orange} from "@material-ui/core/colors";
import filesImg from './files_and_folder.png';
import calendarImg from './calendar.png';
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from '@material-ui/core/DialogActions';
import {DropzoneArea} from 'material-ui-dropzone'
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import './HomePageStyle.css'
import ErrorIcon from '@material-ui/icons/Error';
import WarningIcon from '@material-ui/icons/Warning';
import DoneIcon from '@material-ui/icons/Done';
import Button from '@material-ui/core/Button';
import FutureSessionsTable from "./FutureSessionsTable";
import {DialogContent} from "@material-ui/core";
import {Link} from "react-router-dom";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import AppBar from "./AppBar";
import TimerIcon from '@material-ui/icons/Timer';
import LinearProgress from "@material-ui/core/LinearProgress";

const theme = createMuiTheme({
    palette: {
        primary: cyan,
        secondary: orange,
    },
});

export default function HomePageComponent() {
    const getCurrentDate = () => {
        return new Date().toISOString().substr(0, 10);
    };

    const [showSubmittionDialog, setShowSubmittionDialog] = useState(false);
    const [showFailureDialog, setShowFailureDialog] = useState(false);
    const [showProgressDialog, setShowProgressDialog] = useState(false);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [showCollisionDialog, setShowCollisionDialog] = useState(false);
    const [showErrorDialog, setShowErrorDialog] = useState(false);
    const [newSessionFile, setNewSessionFile] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [progressMessage, setProgressMessage] = useState("");
    const [collisionMessage, setCollisionMessage] = useState("");
    const [date] = useState(getCurrentDate());
    const [futureSessions, setFutureSessions] = useState(null);

    const [id, setId] = useState("");
    const [program, setProgram] = useState("Inbar");
    const [sessionTime, setSessionsTime] = useState("morning");
    const [sessionDate, setSessionDate] = useState(getCurrentDate);

    // login data
    const [user, setUser] = useState(null);
    const [authenticated, setAuthenticated] = useState(null);

    const handleProgramChange = event => {
        setProgram(event.target.value);
    };

    const handleSessionTimeChange = event => {
        setSessionsTime(event.target.value);
    };

    async function fetchData() {
        const res = await fetch(process.env.REACT_APP_BACKEND_URL + "/futureSessions", {
            method: "GET",
            credentials: "include",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": true
            }
        });
        if (res.status === 401) {
            window.location.replace(process.env.REACT_APP_URL)
        }
        res
            .json()
            .then(res => setFutureSessions(res))
    }

    async function checkLogin() {
        fetch(process.env.REACT_APP_BACKEND_URL + "/auth/google/success", {
            method: "GET",
            credentials: "include",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                "Access-Control-Allow-Credentials": true
            }
        }).then(response => {
            if (response.status === 200) return response.json();
            throw new Error("failed to authenticate user");
        })
            .then(responseJson => {
                if (responseJson.success) {
                    setAuthenticated(true);
                    setUser(responseJson.user);
                    // console.log(user);
                } else {
                    setAuthenticated(false);
                    setUser(null);
                    // console.log(user);
                }
            })
            .catch(error => {
                setAuthenticated(false);
            });
    }

    useEffect(() => {
            checkLogin();
            fetchData();
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        []);

    if (!futureSessions || !authenticated) {
        // Returns an empty page until authentication.
        if (authenticated == null) {
            return <div></div>
        }
        // The user isn't logged in
        if (authenticated === false) {
            window.open(process.env.REACT_APP_BACKEND_URL + "/auth/google", "_self");
            // Used for displaying an empty page until redirect
            return <div></div>
        }
        return (
            <ThemeProvider theme={theme}>
                <AppBar isHomePageInput={true} currentView={"HomePage"} position="fixed" authenticated={authenticated}
                        user={user}/>
                <LinearProgress/>
            </ThemeProvider>
        );
    }

    const onDrop = acceptedFiles => {
        setNewSessionFile(acceptedFiles);
        setShowSubmittionDialog(true);
    };

    const onDateChange = newDate => {
        setSessionDate(newDate.target.value);
    };

    const handleCancel = () => {
        document.querySelector('[aria-label="Delete"]').click();
        setShowSubmittionDialog(false);
        setNewSessionFile({files: []});
    };


    const closeErrorDialog = () => {
        document.querySelector('[aria-label="Delete"]').click();
        setShowErrorDialog(false);
    };

    const sendData = async () => {
        setProgressMessage("משבץ");
        setShowProgressDialog(true);

        const formData = new FormData();
        formData.append('file', newSessionFile);
        formData.append('program', program);
        formData.append('sessionTime', sessionTime);
        formData.append('sessionDate', sessionDate);
        try {
            const res = await fetch(process.env.REACT_APP_BACKEND_URL + "/excel", {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                },
                body: formData
            });
            if (res.status === 401) {
                window.location.replace(process.env.REACT_APP_URL)
            }
            const data = await res.json();
            setShowProgressDialog(false);
            if (data.statusText === "Success") {
                setId(data.id);
                setProgram(data.program);
                setSessionsTime(data.time);
                setSessionDate(data.date);
                setShowSuccessDialog(true);
            } else {
                setShowFailureDialog(true);
            }
        }
        catch (error) {
            setShowProgressDialog(false);
            setShowFailureDialog(true);
        }
    };

    const handleCancelCollision = () => {
        document.querySelector('[aria-label="Delete"]').click();
        setShowCollisionDialog(false);
    };

    const handleApproveCollision = () => {
        setShowCollisionDialog(false);
        sendData();
    };

    const handleSuccessDialogClose = () => {
        setShowSuccessDialog(false);
        window.location.reload();
    };

    const handleSubmit = async () => {

        setProgressMessage("בודק ולדיציה");
        setShowSubmittionDialog(false);
        setShowProgressDialog(true);
        const formData = new FormData();
        formData.append('file', newSessionFile);
        formData.append('program', program);
        formData.append('sessionTime', sessionTime);
        formData.append('sessionDate', sessionDate);

        try {
            const res = await fetch(process.env.REACT_APP_BACKEND_URL + "/sessions/validation", {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                },
                body: formData
            });
            if (res.status === 401) {
                window.location.replace(process.env.REACT_APP_URL)
            }
            const data = await res.json();
            if (data.status === "Not Valid") {
                setErrorMessage(data.message);
                setShowProgressDialog(false);
                setShowErrorDialog(true);
            } else if (data.status === "Collision") {
                setCollisionMessage(data.message);
                setShowProgressDialog(false);
                setShowCollisionDialog(true);
            } else if (data.status === "Error") {
                setShowProgressDialog(false);
                setShowFailureDialog(true);
            } else if (data.status === "Valid") {
                setShowProgressDialog(false);
                sendData();
            } else {
                setShowProgressDialog(false);
                setShowFailureDialog(true);
            }
        }
        catch(error) {
            setShowProgressDialog(false);
            setShowFailureDialog(true);
        }
    };

    return (
        <ThemeProvider theme={theme}>
            <AppBar isHomePageInput={true} currentView={"HomePage"} position="fixed" authenticated={authenticated}
                    user={user}/>
            <Dialog open={showProgressDialog}
                    maxWidth={false} dir="rtl">
                <DialogTitle className="ProgressDialog" disableTypography={true} dir="rtl">
                    <div className="Icon">
                        <TimerIcon/>
                    </div>
                    <div className="ProgressHeader">
                        אנא המתן
                    </div>
                </DialogTitle>
                <DialogContent className="ProgressContent">
                    <CircularProgress disableShrink/>
                    <div className="DialogHeader">
                        {progressMessage}
                    </div>
                </DialogContent>
            </Dialog>

            {/*Error dialog - in case the input is not valid.*/}
            <Dialog open={showErrorDialog} onKeyDown={closeErrorDialog}
                    maxWidth={false} dir="rtl">
                <DialogTitle className="ErrorDialogHeader" disableTypography={true}>
                    <div className="Icon">
                        <ErrorIcon/>
                    </div>
                    <div className="DialogHeader">
                        שגיאה בקובץ האקסל
                    </div>
                </DialogTitle>
                <DialogContent className="DialogContent">
                    <div className="ErrorContent">
                        {errorMessage}
                    </div>
                    <br/>
                    <form id="download-form" method="get" action={program === "Inbar" ? "example_inbar.xlsx" : "example.xlsx"}>
                        <div className="Example" onClick={() =>
                            document.getElementById("download-form").submit()
                        }>
                            <div className="linkText">הורד אקסל לדוגמא</div>
                        </div>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeErrorDialog} className="CancelButton">
                        סגור
                    </Button>
                </DialogActions>
            </Dialog>

            {/*Failure dialog - in case the input is not valid.*/}
            <Dialog open={showFailureDialog}
                    maxWidth={false} dir="rtl">
                <DialogTitle className="ErrorDialogHeader" disableTypography={true}>
                    <div className="Icon">
                        <ErrorIcon/>
                    </div>
                    <div className="DialogHeader">
                        העלת שיבוץ חדש נכשלה
                    </div>
                </DialogTitle>
                <DialogContent className="FailureContent">
                    <div className="ErrorContent">
                        אירעה שגיאה - אנא נסה שנית מאוחר יותר.
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        setShowFailureDialog(false)
                    }} className="CancelButton">
                        סגור
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={showCollisionDialog}
                    onClose={() => {
                        setShowCollisionDialog(false)
                    }} maxWidth={false} dir="rtl">
                <DialogTitle className="SubmitDialog" disableTypography={true}>
                    <div className="Icon">
                        <WarningIcon/>
                    </div>
                    <div className="DialogHeader">
                        קיימת התנגשות
                    </div>
                </DialogTitle>
                <DialogContent className="ErrorContent">
                    {collisionMessage}
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleCancelCollision} color="primary" className="CancelButton">
                        בטל
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleApproveCollision}
                            className="SubmitButton">
                        אשר
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={showSuccessDialog}
                    onClose={() => {
                        setShowSuccessDialog(false)
                    }} onKeyDown={handleSuccessDialogClose} onEscapeKeyDown={handleSuccessDialogClose} maxWidth={false}
                    dir="rtl">
                <DialogTitle className="SuccessDialog" disableTypography={true}>
                    <div className="Icon">
                        <DoneIcon/>
                    </div>
                    <div className="DialogHeader">
                        השיבוץ הסתיים!
                    </div>
                </DialogTitle>
                <DialogContent className="ErrorContent">
                    השיבוץ עבר בהצלחה. תוכל לצפות בשיבוץ או להישאר בדף הבית.
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleSuccessDialogClose} color="primary"
                            className="CancelButton">
                        סגור
                    </Button>
                    <Button variant="contained" color="primary"
                        // onClick={handleSuccessDialogMove}
                            className="SubmitButton">
                        <Link to={{
                            pathname: "/teamSessions",
                            state: {
                                id: id,
                                isAuthenticated: authenticated,
                                appBarData: program + ' - ' + sessionDate + ' - ' + sessionTime
                            }
                        }} style={{textDecoration: 'none', color: 'black', fontSize: '14px', display: 'flex'}}>
                            עבור לשיבוץ
                        </Link>
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={showSubmittionDialog}
                    onClose={() => {
                        setShowSubmittionDialog(false)
                    }} onEscapeKeyDown={handleCancel} maxWidth={false} dir="rtl">
                <DialogTitle className="SubmitDialog" disableTypography={true}>
                    <div className="Icon">
                        <InsertDriveFileIcon/>
                    </div>
                    <div className="DialogHeader">
                        הקובץ צורף לבקשה
                    </div>
                </DialogTitle>
                <DialogContent>
                    <div className="Info">רגע לפני שמשבצים, מלא את הפרטים הבאים:</div>
                    <div className="Attr">תאריך</div>
                    <input type="date"
                           className="Calendar"
                           style={{align: "right"}}
                           defaultValue={date}
                           onChange={onDateChange}/>
                    <div className="Attr">תכנית</div>
                    <div>
                        <FormControl component="fieldset">
                            {/*<FormLabel component="legend">Gender</FormLabel>*/}
                            <RadioGroup aria-label="gender" name="gender1" value={program}
                                        onChange={handleProgramChange}
                                        style={{display: "block"}}>
                                <FormControlLabel value="Inbar" control={<Radio/>}
                                                  className="Option" label="ענבר"
                                />
                                <FormControlLabel value="Makom" control={<Radio/>} className="Option" label="מקום"/>
                                <FormControlLabel value="Advot" control={<Radio/>} className="Option" label="אדוות"/>
                                <FormControlLabel value="Amitim" control={<Radio/>} className="Option" label="עמיתים"/>
                            </RadioGroup>
                        </FormControl>
                    </div>
                    <div className="Attr">מועד</div>
                    <div>
                        <FormControl component="fieldset">
                            <RadioGroup aria-label="gender" name="gender1" value={sessionTime}
                                        onChange={handleSessionTimeChange}
                                        style={{display: "block"}}>
                                <FormControlLabel value="morning" control={<Radio/>} className="Option" label="בוקר"/>
                                <FormControlLabel value="afternoon" control={<Radio/>} className="Option"
                                                  label="צהריים"/>
                            </RadioGroup>
                        </FormControl>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={handleCancel.bind(this)} color="primary"
                            className="CancelButton">
                        בטל
                    </Button>
                    <Button variant="contained" color="primary" onClick={handleSubmit} className="SubmitButton">
                        שבץ
                    </Button>
                </DialogActions>
            </Dialog>

            <div className="addNewSession">
                <DropzoneArea
                    className="dropzone"
                    dropzoneClass="dropzoneStyle"
                    dropzoneParagraphClass="dropzoneParagraph"
                    dropzoneText="גרור את קובץ האקסל לשיבוץ או לחץ כאן"
                    acceptedFiles={['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']}
                    filesLimit={1}
                    onDrop={onDrop}
                />
                <div><img src={filesImg} className="Img" alt={""}/></div>
            </div>
            <div className="showFutureSessions">
                <FutureSessionsTable sessions={futureSessions.sessions} authenticated={authenticated}/>
                <div><img src={calendarImg} className="CurrentSessions" alt={""}/></div>
            </div>
        </ThemeProvider>
    );

}
